import React, { useEffect, useRef, useState } from "react";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import TicketList from "./component/TIcketList";
import { Btn } from "../../AbstractElements";
import {
  useAddTicket,
  useTicketConfigStatus,
  useUpdateTicket,
} from "./hooks/useTicket";
import RouteDropdown from "../../Component/BasicComponents/Dropdowns/RouteDropdown";
import PaginatedRouteDropdown from "../../Component/BasicComponents/Dropdowns/PaginatedDropdownWrapper";
import { getOutletFiltersData } from "../POB/hooks/POBRepository";
import { getTicketTypeList } from "./hooks/TicketRepo";
import CustomInput from "../../Component/BasicComponents/CustomInput";
import { Input, Label } from "reactstrap";
import { handleMedia } from "../ProductCatalogue/repositories/BrandCampaignRepository";
import { showToast } from "../../utils/toastUtils";
import { FaTrash } from "react-icons/fa";

const AddTicketModalContent = ({
  setIsModalOpen,
  ticketConfigStatus,
  selectedRow,
  modalStatus,
  setFormValue,
  formValue,
  customer,
  setCustomer,
  ticketType,
  setTicketType,
  setModalStatus,
}: {
  setIsModalOpen?: any;
  ticketConfigStatus?: any;
  selectedRow?: any;
  modalStatus?: string;
  setFormValue?: any;
  formValue?: any;
  customer?: any;
  setCustomer?: any;
  ticketType?: any;
  setTicketType?: any;
  setModalStatus?: any;
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const BASE_URL = "https://tspc-development.truesales.in/media?id=";

  const { mutate: addTicket } = useAddTicket();
  const { mutate: updateTicket } = useUpdateTicket();

  const formattedConfigStatusData =
    Object.entries(ticketConfigStatus?.data || {}).map(([key, value]) => ({
      id: key,
      label: value as string | number,
    })) || [];

  useEffect(() => {
    console.log(
      "🚀 ~ Tickets.tsx:50 ~ AddTicketModalContent ~ selectedRow:",
      selectedRow?.Id
    );

    if (selectedRow && modalStatus === "Edit") {
      setFormValue({
        status: selectedRow?.Status,
        description: selectedRow?.Description,
        media: selectedRow?.MediaId,
      });
      setCustomer({
        id: selectedRow?.OutletId,
        label: selectedRow?.OutletName,
      });
      setTicketType({
        id: selectedRow?.TicketTypeId,
        label: selectedRow?.TicketType,
      });
    }
  }, [selectedRow]);

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      try {
        const mediaId = await handleMedia(file);
        setFormValue((prev: any) => ({ ...prev, media: mediaId }));
      } catch (error) {
        console.error("Media upload failed:", error);
      }
    }
  };

  const handleDropdownSelect = (field: string, value: string | number) => {
    setFormValue((prevState: any) => ({
      ...prevState,
      [field]: value, // Directly assign the selected value
    }));
  };

  const handleInputChange = (
    name: any,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = e.target;

    if (name === "mobile") {
      const numericValue = value.replace(/[^0-9]/g, ""); // allow only numbers
      if (numericValue.length <= 10) {
        setFormValue((prevState: any) => ({
          ...prevState,
          [name]: numericValue,
        }));
      }
      return;
    }

    // Convert specific fields to numbers
    const numericFields = ["mobile", "registration"];
    const updatedValue = numericFields.includes(name)
      ? value.replace(/[^0-9]/g, "")
      : value;

    setFormValue((prevState: any) => ({
      ...prevState,
      [name]: numericFields.includes(name)
        ? updatedValue === ""
          ? ""
          : Number(updatedValue)
        : updatedValue,
    }));
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setFormValue({ status: "", description: "", media: "", ticketId: "" });
    setCustomer(null);
    setTicketType(null);
    setModalStatus("");
  };

  const handleSubmit = () => {
    // console.log("Form Submitted:", formValue);
    // console.log("ticketType:", ticketType);
    // console.log("customer:", customer);

    if (selectedRow && modalStatus === "Edit") {
      if (!customer?.id) {
        showToast.warning("Please Select the Customer Field!");
        return;
      } else if (!formValue?.description.trim()) {
        showToast.warning("Please Fill the Description Field!");
        return;
      } else if (!ticketType?.id) {
        showToast.warning("Please Select the Ticket Type Field!");
        return;
      } else {
        const updateTicketBody = {
          TicketTypeId: ticketType?.id,
          OutletId: customer?.id,
          Description: formValue?.description,
          Status: formValue?.status,
          MediaId: formValue?.media,
        };

        updateTicket(
          { id: selectedRow?.Id, body: updateTicketBody },
          {
            onSuccess: () => {
              handleClose();
            },
            onError: () => {
              setFormValue({
                status: "",
                description: "",
                media: "",
                ticketId: "",
              });
              setCustomer(null);
              setTicketType(null);
              setModalStatus("");
            },
          }
        );
      }
    } else {
      if (!customer?.id) {
        showToast.warning("Please Select the Customer Field!");
        return;
      } else if (!formValue?.description.trim()) {
        showToast.warning("Please Fill the Description Field!");
        return;
      } else if (!ticketType?.id) {
        showToast.warning("Please Select the Ticket Type Field!");
        return;
      } else {
        const addTicketBody = {
          TicketTypeId: ticketType?.id,
          OutletId: customer?.id,
          Description: formValue?.description,
          Status: formValue?.status,
          MediaId: formValue?.media,
        };

        // console.log(
        //   "🚀 ~ Tickets.tsx:131 ~ handleSubmit ~ addTicketBody:",
        //   addTicketBody
        // );

        addTicket(addTicketBody, {
          onSuccess: () => {
            handleClose();
          },
          onError: () => {
            setFormValue({
              status: "",
              description: "",
              media: "",
              ticketId: "",
            });
            setCustomer(null);
            setTicketType(null);
            setModalStatus("");
          },
        });
      }
    }
  };

  return (
    <div>
      <div className="row mb">
        <div className="col-md-6">
          <PaginatedRouteDropdown
            DropdownHeading="Ticket Type"
            initialSelectedOptions={ticketType} // ✅ Only for showing selected
            placeholder="Select Ticket Type"
            onChange={(val: any) => {
              // ✅ You must get { id, label } back (see fix below in component)
              setTicketType(val);
            }}
            fetchOptions={async (page: any, search: any) => {
              const res = await getTicketTypeList({
                search: search || "",
                page,
                limit: 10,
              });

              return (
                res?.data?.data?.map((item: any) => ({
                  id: item?.Id,
                  label: item?.TicketType,
                })) || []
              );
            }}
          />
        </div>
        <div className="col-md-6">
          <PaginatedRouteDropdown
            DropdownHeading="Customer"
            asterisk={true}
            initialSelectedOptions={customer} // ✅ Only for showing selected
            placeholder="Select Customer"
            onChange={(val: any) => {
              // ✅ You must get { id, label } back (see fix below in component)
              setCustomer(val);
            }}
            fetchOptions={async (page: any, search: any) => {
              const res = await getOutletFiltersData({
                search: search || "",
                page,
                limit: 10,
              });

              return (
                Object.entries(res?.data || {})?.map(([key, value]) => ({
                  id: key,
                  label: value as string | number,
                })) || []
              );
            }}
          />
        </div>
      </div>

      <div className="row mb">
        <div className="col-md-6">
          <RouteDropdown
            options={formattedConfigStatusData || []}
            onChange={(value: any) => {
              handleDropdownSelect("status", value);
            }}
            DropdownHeading="Status"
            value={formValue?.status}
            placeholder={"Select Status"}
          />
        </div>
        <div className="col-md-6">
          <CustomInput
            label="Description"
            placeholder="Enter Description"
            type="text"
            asterisk={true}
            name="description"
            value={formValue?.description}
            onChange={(e) => handleInputChange("description", e)}
          />
        </div>
      </div>

      <div className="col-md-6">
        <input
          type="file"
          accept="image/*"
          multiple // ✅ this is required
          ref={fileInputRef}
          onChange={handleFileChange}
          style={{ display: "none" }}
        />
        <Btn
          style={{
            display: "flex",
            backgroundColor: "#43B9B2",
            color: "white",
            justifyContent: "center",
            alignItems: "end",
          }}
          type="submit"
          onClick={handleButtonClick}
        >
          {"Upload Media"}
        </Btn>
      </div>

      <div className="col-sm-12 mt-2">
        {formValue.media && (
          <div className="col-sm-12">
            <Label
              style={{
                fontWeight: "500",
                display: "block",
                marginTop: "18px",
              }}
            >
              Uploaded Media
            </Label>
            <div style={{ position: "relative", display: "inline-block" }}>
              <img
                src={
                  formValue?.media
                    ? `${BASE_URL}${formValue?.media}`
                    : "https://via.placeholder.com/100?text=No+Image"
                }
                alt="Uploaded Media"
                style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: "8px",
                  marginTop: "8px",
                  objectFit: "cover",
                }}
              />
              {/* Trash Icon */}
              <FaTrash
                size={14}
                onClick={() =>
                  setFormValue((prev: any) => ({ ...prev, media: "" }))
                }
                style={{
                  position: "absolute",
                  top: "4px",
                  left: "auto",
                  right: "-1px",
                  cursor: "pointer",
                  color: "red",
                  backgroundColor: "rgba(0,0,0,0.6)",
                  borderRadius: "50%",
                  fontSize: "14px",
                  padding: "4px",
                  width: "20px",
                  height: "20px",
                }}
              />
            </div>
          </div>
        )}
      </div>

      {/* Buttons */}
      <div className="d-flex justify-content-start mt-3 gap-2">
        <Btn
          style={{ backgroundColor: "#43B9B2", color: "white" }}
          type="submit"
          onClick={handleSubmit}
        >
          {modalStatus === "Edit" ? "Update" : "Submit"}
        </Btn>
        <Btn
          style={{
            backgroundColor: "#F9FAFC",
            color: "#000",
            border: "1px solid #E0E0E0",
          }}
          type="button"
          onClick={handleClose}
        >
          Cancel
        </Btn>
      </div>
    </div>
  );
};

const Ticket: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [modalStatus, setModalStatus] = useState("");
  const [formValue, setFormValue] = React.useState({
    status: "",
    description: "",
    media: "",
    ticketId: "",
  });
  const [customer, setCustomer] = useState<{
    id: number;
    label: string;
  } | null>(null);
  const [ticketType, setTicketType] = useState<{
    id: number;
    label: string;
  } | null>(null);

  const toggle = () => {
    setTicketType(null);
    setCustomer(null);
    setFormValue({
      status: "",
      description: "",
      media: "",
      ticketId: "",
    });
    setModalStatus("");
    setSelectedRow(null);
    setIsModalOpen(false);
  };

  const { data: ticketConfigStatus } = useTicketConfigStatus({ enable: true });

  return (
    <div className="p-2">
      <PageHeader
        title="Ticketing"
        buttons={[
          {
            label: "+ Add Ticket",
            onClick: () => setIsModalOpen(!isModalOpen),
            color: "#2e8dd3",
          },
        ]}
      />

      <div style={{ flex: "1", minWidth: "100%", maxWidth: "100%" }}>
        <TicketList
          setIsModalOpen={setIsModalOpen}
          setSelectedRow={setSelectedRow}
          ticketConfigStatus={ticketConfigStatus}
          setModalStatus={setModalStatus}
        />
      </div>

      <RouteModal
        isOpen={isModalOpen}
        title={modalStatus === "Edit" ? "Edit Ticket" : "Add Ticket"}
        toggle={toggle}
        size="lg"
        content={
          <AddTicketModalContent
            setIsModalOpen={setIsModalOpen}
            ticketConfigStatus={ticketConfigStatus}
            selectedRow={selectedRow}
            modalStatus={modalStatus}
            setFormValue={setFormValue}
            formValue={formValue}
            customer={customer}
            setCustomer={setCustomer}
            ticketType={ticketType}
            setTicketType={setTicketType}
            setModalStatus={setModalStatus}
          />
        }
      />
    </div>
  );
};
export default Ticket;
